module.exports = __webpack_public_path__ + "img/Polygon2.2d91b782.svg";